"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Skeleton } from "@/components/ui/skeleton";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
            <Skeleton className="aspect-video w-full rounded-lg" />
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="mt-2 h-9 w-full" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-10 text-center text-sm text-destructive">
        Failed to load travel specials. Please try again later.
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-10 text-center text-sm text-muted-foreground">
        No travel specials available at the moment.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
      {products.map((product, i) => {
      const isSale = product.discounted_price !== undefined && product.discounted_price < product.price;
      return <div key={product.id} data-index={i} className="group flex flex-col gap-3">
            <Link to={product.link} className="relative block overflow-hidden rounded-lg bg-muted aspect-video">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                  No Image
                </div>}
              
              {isSale && <span className="absolute right-2 top-2 z-10 flex h-10 w-10 items-center justify-center rounded-lg bg-purple-600 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm">
                  Sale
                </span>}
            </Link>

            <div className="flex flex-1 flex-col">
              <Link to={product.link}>
                <h3 className="font-default text-base font-semibold leading-tight text-foreground transition-colors group-hover:text-primary line-clamp-2 mb-1.5">
                  {product.title}
                </h3>
              </Link>
              
              <div className="mt-auto flex items-center gap-2 text-sm">
                {isSale ? <>
                    <span className="text-slate-500 line-through">
                      R{product.price.toFixed(2)}
                    </span>
                    <span className="font-bold text-foreground">
                      R{product.discounted_price!.toFixed(2)}
                    </span>
                  </> : <span className="font-bold text-foreground">
                    R{product.price.toFixed(2)}
                  </span>}
              </div>
            </div>

            <div className="pt-2">
              <AddToCartButton productId={product.id} variant="outline" size="sm" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 border-transparent" text="Book Now" showQuantity={false} />
            </div>
          </div>;
    })}
    </div>;
}
export default function FeaturedTravelSpecials() {
  return <section id="featuredtravelspecials" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-default text-2xl font-bold uppercase tracking-wider text-foreground md:text-3xl">
            Shop
          </h2>
        </div>
        
        <EcommerceProductsProvider wp_query={{
        per_page: 5,
        orderby: "date",
        order: "desc"
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}